import { Box, Typography } from '@mui/material';
import { useThemeContext } from '../../contexts/BaseThemeContextProvider';

export const isTestKitActivationDisabled = () => {
  const now = new Date();
  const start = new Date('2025-11-01T08:00:00');
  const end = new Date('2025-11-02T08:00:00');
  return now >= start && now <= end;
};

const DisableActivation = () => {
  const { theme } = useThemeContext();
  return (
    <Box>
      <Typography variant="body1" sx={{ marginTop: '8px' }}>
        Our lab is closed for the holidays. We will reopen on January 2nd. This means we cannot process your sample
        during this time. Therefore, we ask that you don't collect your sample until at least January 1st.
      </Typography>

      <Typography
        sx={{
          fontSize: '1rem',
          mt: 1,
          mb: 2,
        }}
        color={theme.custom.buttonTextColorVariantOne}
        align="left"
      >
        Activation will be enabled again from December 28th.
      </Typography>
    </Box>
  );
};

export default DisableActivation;
